import DailyRoutine from "../types/DailyRoutine"

const GetRoutine = (dailyRoutineTemplate: DailyRoutine[], day: string): DailyRoutine | undefined => {
    return (dailyRoutineTemplate.find((routine) => routine.dayOfWeek === day))
}

export default GetRoutine